import { combineReducers } from "redux";
import ProfileReducer from "../admin/profileReducer";
import AdmissionReducer from "../admissions/admissionsReducer";
import attenderReducer from "../Attender/attenderReducer";
import AuthReducer from "../auth/authReducer";
import BlockReducer from "../block/blockReducer";
import DashboardReducer from "../dashboard/dashboardReducer";
import departmentReducer from "../department/departmentReducer";
import doctorReducer from "../doctor/doctorReducer";
import floorReducer from "../floor/floorReducer";
import organizationReducer from "../organization/organizationReducer";
import PatientReducer from "../patient/patientReducer";
import RoleReducer from "../role/roleReducer";
import securityOfficerReducer from "../secuityOfficer/securityReducer";
import specialistReducer from "../specialist/specialistReducer";
import staffReducer from "../staff/staffReducer";
import transferPatientReducer from "../TransferPatient/transferPatientReducer";
import valueReducer from "../value/storeReducer";
import wardReducer from "../ward/wardReducer";


const rootReducer = combineReducers({
  auth: AuthReducer,
  patients:PatientReducer,
  securityOfficer:securityOfficerReducer,
  doctor:doctorReducer,
  block:BlockReducer,
  floor:floorReducer,
  ward:wardReducer,
  values: valueReducer,
  department:departmentReducer,
  specialist:specialistReducer,
  staffs:staffReducer,
  role:RoleReducer,
  transferPatient:transferPatientReducer,
  attender:attenderReducer,
  admission:AdmissionReducer,
  dashboard:DashboardReducer,
  profile:ProfileReducer,
  organization: organizationReducer,
});

export default rootReducer;
